import CurriculumManager from '../content/CurriculumManager';
import gameNames from '../../hub/data/GameIds';

const initialState = {
  gridItems: [],
  availableItems: [],
  // contains a object that should be compared with selected item
  missingItemPlaceholder: null,
  setType: '',
  setId: '',
  zapsEarned: 0,
};

const curriculumReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'LOAD_STAGE_DATA':
      CurriculumManager.populateData(action.payload.level);
      return {
        ...state,
        gridItems: CurriculumManager.getGridItems(),
        availableItems: CurriculumManager.getAvailableItems(),
        setType: CurriculumManager.getItemsSetType(action.payload.level),
        setId: CurriculumManager.getItemsSetId(action.payload.level),
        // zaps earned for competing current data set
        zapsEarned: CurriculumManager.getZapsEarned(action.payload.level),
        missingItemPlaceholder: CurriculumManager.getMissingItemPlaceholder(),
      };
    case 'RESET_STAGE_DATA':
      CurriculumManager.reloadGrids();

      return {
        ...state,
        gridItems: CurriculumManager.getGridItems(),
        availableItems: CurriculumManager.getAvailableItems(),
        missingItemPlaceholder: CurriculumManager.getMissingItemPlaceholder(),
      };
    case 'REDUCE_STAGE_DATA':
      return {
        ...state,
        availableItems: CurriculumManager.getFewAvailableItems(),
      };
    case 'NEXT_STANDARD_ITEM':
      CurriculumManager.nextStandardItem();

      return {
        ...state,
        gridItems: CurriculumManager.getGridItems(),
        availableItems: CurriculumManager.getAvailableItems(),
        missingItemPlaceholder: CurriculumManager.getMissingItemPlaceholder(),
      };

    default:
      return state;
  }
};

export default curriculumReducer;
